function ProgressBar({ percentageCompleted, customClassName }) {
    return (
        <div className={`progress ProgressBar ${customClassName}`} role="progressbar" aria-label="Success example" aria-valuenow={percentageCompleted} aria-valuemin="0" aria-valuemax="100">
            <div className="progress-bar" style={{ width: `${percentageCompleted}%` }}></div>
        </div>
    )
}

export { ProgressBar };